import { supabase } from '../lib/supabase';

export type NotificationEmailSettings = {
  orderUpdates?: boolean;
  promotions?: boolean;
  securityAlerts?: boolean;
  weeklyDigest?: boolean;
};

export type NotificationPushSettings = {
  newMessages?: boolean;
  orderStatus?: boolean;
  priceDrops?: boolean;
  recommendations?: boolean;
};

export interface UserSettingsRow {
  user_id: string;
  email: NotificationEmailSettings;
  push: NotificationPushSettings;
  created_at?: string;
  updated_at?: string;
}

export class UserSettingsService {
  static async getMySettings(): Promise<UserSettingsRow | null> {
    const { data: { user }, error: authErr } = await supabase.auth.getUser();
    if (authErr) throw authErr;
    if (!user) return null;

    const { data, error } = await supabase
      .from('user_settings')
      .select('user_id, email, push, created_at, updated_at')
      .eq('user_id', user.id)
      .single();

    if (error && error.code !== 'PGRST116') throw error;
    return (data as any) ?? null;
  }

  static async upsertMySettings(payload: { email: NotificationEmailSettings; push: NotificationPushSettings }): Promise<UserSettingsRow> {
    const { data: { user }, error: authErr } = await supabase.auth.getUser();
    if (authErr) throw authErr;
    if (!user) throw new Error('User not authenticated');

    const toSave = {
      user_id: user.id,
      email: payload.email ?? {},
      push: payload.push ?? {},
      updated_at: new Date().toISOString(),
    };

    const { data, error } = await supabase
      .from('user_settings')
      .upsert(toSave, { onConflict: 'user_id' })
      .select('user_id, email, push, created_at, updated_at')
      .single();

    if (error) throw error;
    return data as unknown as UserSettingsRow;
  }
}
